module.exports = __webpack_public_path__ + "img/68.b3a000f3.jpg";